/**
 * @desc 处理投诉
 */
import {
  ComplaintEntity,
  HandleComplaintForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type HandleComplaintParameter = HandleComplaintForm

const method = 'PUT'
const url = '/trade/operation/complaint/handleComplaint'

export const handleComplaintApi = (
  data?: HandleComplaintParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<ComplaintEntity>({
    method,
    url,
    data,
    ...config
  })
}

handleComplaintApi.method = method
handleComplaintApi.url = url
